import { switchMap, map, catchError, pluck } from 'rxjs/operators';
import { inject, Injectable } from '@angular/core';
import { Actions, createEffect, ofType } from '@ngrx/effects';

import { of } from 'rxjs';
import * as fromActions from '../actions/user.actions';
import { User } from '../../models';
import { UserService } from 'app/core/services/user.service';

const constructErrorMsg = (resp: any): string => {
  const defaultMsg = 'Registration Failure';
  const errorIsValid = !!resp.error;
  const msgIsValid = !!resp.message;
  const result = errorIsValid && msgIsValid ? `${resp.message} ${resp.error}` : defaultMsg;
  return result;
};

@Injectable()
export class UserEffects {
  actions$ = inject(Actions);
  userService = inject(UserService);

  loadUser$ = createEffect(() =>
    this.actions$.pipe(
      ofType(fromActions.LOAD_USER),
      switchMap(() =>
        this.userService.getCurrentUserData().pipe(
          map((user: User) => new fromActions.LoadUserSuccess(user)),
          catchError((error: any) => of(new fromActions.LoadUserFail(error))),
        ),
      ),
    ),
  );

  createNewUser$ = createEffect(() =>
    this.actions$.pipe(
      ofType(fromActions.CREATE_NEW_USER),
      pluck('payload'),
      switchMap((userData: User) => {
        const user = { ...userData };
        user.userName = user.emailAddress;
        return this.userService.createNewUser(user).pipe(
          map((response: any) =>
            response && !response.error
              ? new fromActions.CreateNewUserSuccess()
              : new fromActions.CreateNewUserFail({
                  errorMsg: constructErrorMsg(response),
                }),
          ),
          catchError((error: any) => of(new fromActions.CreateNewUserFail(error))),
        );
      }),
    ),
  );

  updateUserData$ = createEffect(() =>
    this.actions$.pipe(
      ofType(fromActions.UPDATE_USER_DATA),
      pluck('payload'),
      switchMap((user: User) =>
        this.userService.updateUserData(user).pipe(
          map(() => new fromActions.UpdateUserSuccess(user)),
          catchError((error: any) => of(new fromActions.UpdateUserDataFail(error))),
        ),
      ),
    ),
  );
}
